import { Action, Resource } from '../api/graphql';
import { usePermissions } from './permissions';
import { useCurrentAgencyUser } from './current-user';

/** True when customer-facing usage billing is enabled for this user/org. */
export const useSettingsUsageTabEnabled = (): boolean => {
  return useCurrentAgencyUser().settingsUsageTabEnabled;
};

/** True when Settings → Usage should be visible (usage billing gate + subscription update). */
export const useCanViewSettingsUsageTab = (): boolean => {
  const { hasPermission } = usePermissions();
  const agencyUser = useCurrentAgencyUser();
  return agencyUser.settingsUsageTabEnabled && hasPermission(Resource.Subscription, Action.Update);
};
